import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { PlayerCardsContextData } from "./PlayerCardsContext";
import { LiquidVariable, PlayerCardServices } from "../../../services/bedrock";
import { useLocalStorage } from "../../../utils";

export interface PlaceholderContextData {
  placeholders: { [key: string]: { [key: string]: string } };
  displayPlaceholders: boolean;
  setDisplayPlaceholders: (displayPlaceholders: boolean) => void;
}

export const InitialPlaceholderContextData: PlaceholderContextData = {
  placeholders: {},
  displayPlaceholders: true,
  setDisplayPlaceholders: () => {},
};

export const PlaceholderContext = (PlayerCards: PlayerCardsContextData): PlaceholderContextData => {
  const [displayPlaceholders, setDisplayPlaceholders] = useLocalStorage("displayPlayerCardPlaceholders", true);
  const [defaultLiquidVariables, setDefaultLiquidVariables] = useState<LiquidVariable[]>([]);

  useEffect(() => {
    PlayerCardServices.getLiquidVariables()
      .then(({ liquidVariables }) => setDefaultLiquidVariables(liquidVariables))
      .catch(console.error);
  }, []);

  const getPlaceholderEntries = (liquidVariables: LiquidVariable[], chainedKeys: string[]): [string, string][] => {
    var entries: [string, string][] = [];
    liquidVariables.forEach(liquidVariable => {
      if (liquidVariable.dataType === "liquid_drop") {
        const subEntries = getPlaceholderEntries(liquidVariable.value as LiquidVariable[], [
          ...chainedKeys,
          liquidVariable.name,
        ]);
        subEntries.forEach(([subKey, subValue]) => {
          entries.push([_.startCase(liquidVariable.name) + " " + subKey, subValue]);
        });
      } else {
        entries.push([_.startCase(liquidVariable.name), [...chainedKeys, liquidVariable.name].join(".")]);
      }
    });
    return entries;
  };

  const placeholders = useMemo(() => {
    var liquidVariables: LiquidVariable[] = PlayerCards.selectedPlayerCard?.liquidVariables || defaultLiquidVariables;
    var groupedEntries: { [key: string]: { [key: string]: string } } = {};
    liquidVariables.forEach(liquidVariable => {
      if (liquidVariable.dataType === "liquid_drop") {
        groupedEntries[liquidVariable.name] = Object.fromEntries(
          getPlaceholderEntries(liquidVariable.value as LiquidVariable[], [liquidVariable.name])
        );
      }
    });

    return groupedEntries;
  }, [PlayerCards.selectedPlayerCard?.liquidVariables, defaultLiquidVariables]);

  return {
    placeholders,
    displayPlaceholders,
    setDisplayPlaceholders,
  };
};
